var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i-select',{attrs:{"filterable":"","autofocus":"","size":"large"},on:{"input":_vm.onChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.tickets),function(option,index){return _c('i-option',{key:index,attrs:{"value":option.value}},[_vm._v(_vm._s(option.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }